import { defineMessages } from 'react-intl';

export default defineMessages({
    insured: {
        id: 'ml.quoteandbind.ho.policySummary.Insured',
        defaultMessage: 'Insured'
    },
    billing: {
        id: 'ml.quoteandbind.ho.policySummary.Billing',
        defaultMessage: 'Billing'
    },
    quoteX: {
        id: 'ml.quoteandbind.ho.policySummary.Quote #',
        defaultMessage: 'Quote #: {quoteId}'
    },
    specialLimitationDescription: {
        id: 'ml.quoteandbind.ho.policySummary.specialLimitationDescription',
        defaultMessage: 'These categories are covered up to the dollar amount and/or loss cause shown.'
    },
    specialLimitationDescriptionGpa: {
        id: 'ml.quoteandbind.ho.policySummary.specialLimitationDescriptionGpa',
        defaultMessage: 'Additional coverage can be obtained by adding either the Value Personal Property or Scheduled Personal Property optional coverage.'
    },
    coverageTotal: {
        id: 'ml.quoteandbind.ho.policySummary.Coverage Total',
        defaultMessage: 'Coverage Total'
    },
    policyCoverages: {
        id: 'ml.quoteandbind.ho.policySummary.Policy coverages',
        defaultMessage: 'Policy coverages'
    },
    coverages: {
        id: 'ml.quoteandbind.ho.policySummary.coverages',
        defaultMessage: 'Coverages'
    },
    optionalCoverages: {
        id: 'ml.quoteandbind.ho.policySummary.Optional Coverages',
        defaultMessage: 'Optional Coverages'
    },
    exclusions: {
        id: 'ml.quoteandbind.ho.policySummary.Exclusions',
        defaultMessage: 'Exclusions'
    },
    exclusionsDescription: {
        id: 'ml.quoteandbind.ho.policySummary.exclusionsDescription',
        defaultMessage: 'You\'ve selected to exclude coverage for the following:'
    },
    perYear: {
        id: 'ml.quoteandbind.ho.policySummary.perYear',
        defaultMessage: '/year'
    },
    policyX: {
        id: 'ml.quoteandbind.ho.policySummary.Policy #',
        defaultMessage: 'Policy #{policyId}'
    },
    changeEffectiveDate: {
        id: 'ml.quoteandbind.ho.policySummary.Changes effective x',
        defaultMessage: 'Changes effective {date}'
    },
    changeConfirmationText: {
        id: 'ml.quoteandbind.ho.policySummary.Below are your changes. Confirm what is listed below is correct.',
        defaultMessage: 'Below are your changes. Confirm what is listed below is correct.'
    },
    editCoverages: {
        id: 'ml.quoteandbind.ho.policySummary.Edit Coverages',
        defaultMessage: 'Edit Coverages'
    },
    insuranceSummaryText: {
        id: 'ml.quoteandbind.ho.policySummary.This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.',
        defaultMessage: 'This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.'
    },
    vieworeditText: {
        id: 'ml.quoteandbind.ho.policySummary.View/Edit Changes',
        defaultMessage: 'View/Edit Changes'
    },
    vpp: {
        id: 'ml.quoteandbind.ho.policySummary.Valuable Personal Property',
        defaultMessage: 'Valuable Personal Property'
    },
    spp: {
        id: 'ml.quoteandbind.ho.policySummary.Scheduled Personal Property',
        defaultMessage: 'Scheduled Personal Property'
    },
    firstPersonInControl: {
        id:'ml.quoteandbind.ho.policySummary.firstPersonInControl',
        defaultMessage: 'First Person in Control'
    },
    secondPersonInControl: {
        id: 'ml.quoteandbind.ho.policySummary.secondPersonInControl',
        defaultMessage: 'Second Person in Control'
    },
    coInsured: {
        id: 'ml.quoteandbind.ho.policySummary.CoInsured',
        defaultMessage: 'Co-Insured'
    },
});
